import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Label } from 'recharts';
import { PARTITION_THD, POSSIBLE_CHART_COLORS } from '../../utils/constants';
import { StringUtils } from '../../utils/strings';
import { SimpleDateUtils } from '../../utils/dates';
import CustomTooltip from "./customTooltip";
import { useLocation } from 'react-router-dom';

  const BuildArea = (name, thisColor) => <Area key={name} type="linear" dataKey={name} stackId="1" stroke={thisColor} fill={thisColor}/>

  const DynamicChart = ({fullData, currentState}) => {

    const {topValues: stack, data: filteredData} = fullData;

    //for THD partion pages use larger chart
    const location = useLocation();
    const useLarger = location.pathname.includes(PARTITION_THD);

    return (
      <div className={useLarger ? "main-chart main-chart-larger" : "main-chart"}>
        <ResponsiveContainer>
          <AreaChart 
            width={500} 
            height={400}
            data={filteredData}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="date" 
              tickFormatter={(date) => SimpleDateUtils.getShoterFriendlyDate(date)}
              />
            <YAxis tickFormatter={(value) => StringUtils.formatNumberAbbreviation(value)}/>
            <Label value={currentState === "revenue" ? "Revenue(€)" : "Impressions"} position={{x: 14, y: -24}} />
            <Tooltip content={<CustomTooltip/>}/>
            {!useLarger && <Legend verticalAlign="top" height={30}/>}
            {stack.map((item,index) => BuildArea(item, POSSIBLE_CHART_COLORS[index]))}
          </AreaChart>
        </ResponsiveContainer>
        </div>
    );
}

export default DynamicChart;